const Download = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.1133 9.3125L8.33203 15.1133C8.14844 15.2969 7.85156 15.2969 7.66797 15.1133L1.88672 9.3125C1.70313 9.12891 1.70313 8.83203 1.88672 8.64844L2.16406 8.37109C2.34766 8.1875 2.64453 8.1875 2.82812 8.37109L7.33594 12.9023V0.71875C7.33594 0.460938 7.54688 0.25 7.80469 0.25H8.19531C8.45312 0.25 8.66406 0.460938 8.66406 0.71875V12.9023L13.1719 8.375C13.3555 8.19141 13.6523 8.19141 13.8359 8.375L14.1133 8.65234C14.2969 8.83203 14.2969 9.12891 14.1133 9.3125ZM15.5 17.2812V16.9688C15.5 16.7109 15.2891 16.5 15.0312 16.5H0.96875C0.710938 16.5 0.5 16.7109 0.5 16.9688V17.2812C0.5 17.5391 0.710938 17.75 0.96875 17.75H15.0312C15.2891 17.75 15.5 17.5391 15.5 17.2812Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Download
